window.onload = function() {
  const icons = new XMLHttpRequest();
  icons.open("GET", '//www.possen.com/cdn/shop/t/35/assets/Icons.sprite?v=1600265784943698661787930749', true);
  icons.send();
  icons.onload = function() {
    const div = document.createElement('div');
    div.className = 'svgSprite';
    div.innerHTML = icons.responseText;
    document.body.insertBefore(div, document.body.childNodes[0]);
  };
};

$(document).ready(function() {
  // General Setup
  const menuButton = $('svg.icons.menu');
  const header = $('.header');
  let lastScrollTop = 0;
  const drawer = $(".mobile-drawer");
  const bottomRow = $('.bottomRow');
  const navigation = $('nav[role=navigation]');
  const navigationLi = $('.navigationlist li .top-level');
  const backBtn = $(".back-btn");
  const cartCount = $('.cart-count');

  // Cart Count Visibility
  if (cartCount.html() == 0) {
    cartCount.hide();
  } else {
    cartCount.show();
  }

  // Removed header hide-on-scroll behavior to keep header visible during scroll

  // Detect mobile devices
  function isMobile() {
    return window.innerWidth <= 960; // Adjust this value based on your breakpoint
  }

  // Handle menu button click
  menuButton.on("click", function() {
    $(this).find('use').attr("href", function(i, val) {
      return val === '#align-left' ? '#exit' : '#align-left';
    });
    drawer.toggleClass("-show");
    header.toggleClass('-mobile-active');
    bottomRow.toggleClass("eventer");
    if (navigation.hasClass("slided")) {
      navigation.removeClass('slided');
    }
  });

  $(document).ready(function() {
    const isArchiveMenu = $('body').hasClass('archive-page'); // Assuming you set a body class for archive pages
  
    // Handle navigation item click
    navigationLi.on("click", function(e) {
      const selected = $(this);

      // Only a category with a submenu slides the phone drawer over to it.
      // Everything else — FW26, SS26, the Shop link, archive links, and any
      // link on desktop — simply follows its href. This used to intercept
      // every top-level tap on phones, so FW26 and SS26 slid to an empty
      // panel and could not be reached; and on desktop it assigned
      // `selected.find('a').attr('href')` (undefined: `selected` IS the
      // link) to location.href, which only worked because the browser's own
      // navigation to the real href happened after it.
      const hasSubmenu = selected.siblings('.submenu-Container').length > 0;
      if (isArchiveMenu || !isMobile() || !hasSubmenu) return;

      const topLinkDiv = $(".mobile-top-link");
      const clone = selected.clone();

      // Remove the span inside the a tag
      clone.find('span').remove();
      clone.text("Shop " + clone.text());

      e.preventDefault(); // Prevent the default anchor action on mobile
      topLinkDiv.html(clone);
      selected.siblings('div').addClass('active');
      navigation.addClass('slided');
    });
  
    // Handle back button click in the mobile sub-menu
    backBtn.on("click", function() {
      navigation.removeClass('slided');
      navigationLi.siblings('div').removeClass('active');
      $(".mobile-top-link").html(''); // Clear the top link div
    });
  
    // Handle window resize to detect mobile/desktop switch
    $(window).on('resize', function() {
      if (!isMobile()) {
        navigation.removeClass('slided');
        navigationLi.siblings('div').removeClass('active');
        $(".mobile-top-link").html('');
      }
    });
  });
  
  
  
  // document.ready function
  $(document).ready(function() {
    // Initialize Slick for GuideSlider
    var GuideSlider = $('.GuideSlide');
    var currentSlide = 1;
    var slide = document.querySelectorAll('[data-slide]');
    var totalSlides = slide.length;
    var progressBar = document.querySelector('.progressBar .progress');
    var currentSlideEl = document.querySelector('.currentSlide');
    var totalSlidesEl = document.querySelector('.totalSlides');
    var slideNavEl = document.querySelector('.slideNavEl');

  GuideSlider.slick({
    infinite: true,
    centerMode: true,
    prevArrow: '<span class="slide-arrow "><svg class="icons prev-arrow chevron-prev"><use href="#chevron-right"></use></svg></span>',
    nextArrow: '<span class="slide-arrow "><svg class="icons next-arrow chevron-next"><use href="#chevron-right"></use></svg></span>',
    appendArrows: slideNavEl,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 4,
          infinite: true
        }
      },
      {
        breakpoint: 1342,
        settings: {
          slidesToShow: 3,
          infinite: true
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          infinite: true
        }
      }
    ]
  });

  // Update Slide Counter
  function updateSlide() {
    currentSlideEl.innerHTML = currentSlide;
    totalSlidesEl.innerHTML = totalSlides;
    progressBar.style.width = (currentSlide / totalSlides) * 100 + '%';
  }

  updateSlide();

  // Next Slide Function
  function nextSlide() {
    if (currentSlide < totalSlides) {
      currentSlide++;
      updateSlide();
    } else {
      currentSlide = 1;
      updateSlide();
    }
  }

  // Previous Slide Function
  function prevSlide() {
    if (currentSlide > 1) {
      currentSlide--;
      updateSlide();
    } else {
      currentSlide = totalSlides;
      updateSlide();
    }
  }

  // Slide Navigation Event Listener
  slideNavEl.addEventListener('click', function(e) {
    if (e.target.classList.contains('next-arrow')) {
      nextSlide();
    } else if (e.target.classList.contains('prev-arrow')) {
      prevSlide();
    }
  });

  // Handle swipe events to update the counter
  GuideSlider.on('swipe', function(event, slick, direction) {
    if (direction === 'left') {
      nextSlide();
    } else if (direction === 'right') {
      prevSlide();
    }
  });

  });






   
  
  


  // Additional Custom Functionality
  const stepDiv = $('.step-div');
  const progression = $('.progressionLine .progression');
  const buttonContainer = $(".button-container");
  const liningContainer = $(".lining-container");
  const Items = $('.collection-grid-item');
  let selection;
  const ButtonsInput = $('#ButtonsInput');
  const LiningsInput = $('#LiningsInput');

  stepDiv.on('click', function () {
    stepDiv.removeClass("active");
    const step = $(this);

    if (step.attr('data-nav') == "buttons") {
      progression.css("width", 0);
      liningContainer.slideUp();
      buttonContainer.slideDown();
    } else if (step.attr('data-nav') == "linings") {
      progression.css("width", "50%");
      liningContainer.slideDown();
      buttonContainer.slideUp();
    } else {
      progression.css("width", "100%");
    }
    
    setTimeout(() => {
      step.addClass("active");
    }, 200);
  });

  Items.on('click', function () {
    const Item = $(this);
    selection = Item.children("p").attr('data-selection');
    
    if (Item.attr("data-type") == 'Buttons') {
      ButtonsInput.trigger('click');
      ButtonsInput.val(selection);
    } else {
      LiningsInput.trigger('click');
      LiningsInput.val(selection);
    }

    if (ButtonsInput.val() != '') {
      $(".step-div[data-nav = 'buttons']").addClass("complete");
    }

    if (LiningsInput.val() != '') {
      $(".step-div[data-nav = 'linings']").addClass("complete");
    }
  });

 
  

});

